{
  "main": {
    "Dashboards": "Dashboards",
    "Properties": "Properties",
    "Asset Management": "Asset Management",
    "Controls": "Controls",
    "Property Services": "Property Services",
    "Alarms": "Alarms",
    "Reports": "Reports",
    "Settings": "Settings",
    "Energy Dashboard": "Energy Dashboard"
  },
  "properties": {
    "You have {count} unread alerts_one": "You have {{count}} unread alert",
    "You have {count} unread alerts_other": "You have {{count}} unread alerts",
    "All installations are running smoothly.": "All installations are running smoothly.",
    "Choose an address first": "choose an address first",
    "Properties": "Properties",
    "New Property": "New Property",
    "Edit Property": "Edit Property",
    "Delete Property": "Delete Property",
    "Remove": "Remove",
    "Are you sure you want to remove property": "Are you sure you want to remove property",
    "You cannot delete the property": "You cannot delete the property",
    "because the following items are blocking deletion.": "because the following items are blocking deletion.",
    "To delete the property, you must first remove the following items.": "To delete the property, you must first remove the following items.",
    "Devices": "Devices",
    "Dashboard": "Dashboard",
    "Widgets": "Widgets",
    "Attention": "Attention",
    "Current Month's Consumption": "Current Month's Consumption",
    "Actual Costs": "Current Monthly Costs",
    "Name": "Name",
    "Address": "Address",
    "Timezone": "Timezone",
    "Currency": "Currency",
    "Contacts": "Contacts",
    "Select Users": "Select Users",
    "Surname": "Surname",
    "Email": "Email",
    "Role": "Role",
    "Phone": "Phone",
    "Choose an Image": "Choose an Image",
    "Heated Floor Area": "Heated Floor Area",
    "Value must be positive": "Value must be positive",
    "Heating System Type": "Heating System Type",
    "Electricity": "Electricity",
    "Natural Gas": "Natural Gas",
    "District Heating": "District Heating",
    "Oil": "Oil",
    "Heat Pump Air": "Heat Pump Air",
    "Heat Pump Earth": "Heat Pump Earth",
    "Category": "Category",
    "Healthcare": "Healthcare",
    "Industrial": "Industrial",
    "Hotel": "Hotel",
    "Office": "Office",
    "Office/Residential": "Office/Residential",
    "Other": "Other",
    "Residential": "Residential",
    "Retail": "Retail",
    "Retail/office": "Retail/office",
    "Warehouse": "Warehouse",
    "Heating Energy Consumption": "Heating Energy Consumption",
    "Electrical Energy Consumption": "Electrical Energy Consumption",
    "Construction Year": "Construction Year",
    "Please enter a valid year (e.g. 2020)": "Please enter a valid year (e.g. 2020)",
    "Today's Consumption": "Today's Consumption",
    "Sort: {label}": "Sort: {{label}}",
    "Priority": "Priority",
    "Alphabetic (A-Z)": "Alphabetic (A-Z)",
    "Alphabetic (Z-A)": "Alphabetic (Z-A)",
    "cancel": "cancel",
    "Create": "Create",
    "Save": "Save",
    "Update": "Update",
    "This field is required": "This field is required",
    "{name} was created successfully": "{{name}} was created successfully",
    "{name} was updated successfully": "{{name}} was updated successfully",
    "Property deleted successfully": "Property deleted successfully",
    "An error occurred while creating {name}": "An error occurred while creating {{name}}",
    "An error occurred while updating {name}": "An error occurred while updating {{name}}",
    "An error occurred while deleting property": "An error occurred while deleting property",
    "Back": "back",
    "Next": "Next",
    "Add Key Contact": "Add Key Contact",
    "Add Contacts": "Add Contacts",
    "Phone is not valid (e.g., +39...)": "Phone is not valid (e.g., +39...)",
    "Email is not valid (e.g., user@example.com)": "Email is not valid (e.g., user@example.com)",
    "Address is not valid": "Address is not valid",
    "Please fill in all required fields before moving forward": "Please fill in all required fields before moving forward",
    "Some fields are not valid": "Some fields are not valid",
    "Add Gateway": "Add Gateway"
  },
  "property_details": {
    "Properties": "Properties",
    "Property Details": "Property Details",
    "You have a total of {tot} events, {totAlerts} of which requires your attention": "You have a total of {{tot}} events, {{totAlerts}} of which requires your attention",
    "You have a total of {tot} devices, {totAlerts} of which requires your attention": "You have a total of {{tot}} devices, {{totAlerts}} of which requires your attention",
    "Property not found": "Property not found",
    "Today's Details": "Today's Details",
    "Current Month's Consumption": "Current Month's Consumption",
    "Today's Consumption": "Today's Consumption",
    "Actual costs": "Current Monthly Costs",
    "Key contacts": "Key contacts",
    "Events": "Events",
    "Devices": "Devices",
    "tabs": {
      "property_events": {
        "Name": "Name",
        "State": "State",
        "Last update": "Last update",
        "Condition": "Condition",
        "Offline": "Offline",
        "Okay": "Okay",
        "In alarm": "In alarm"
      },
      "property_devices": {
        "Name": "Name",
        "State": "State",
        "Last update": "Last update",
        "Condition": "Condition",
        "Offline": "Offline",
        "Okay": "Okay",
        "In alarm": "In alarm",
        "Category": "Category",
        "Communication Protocol": "Communication Protocol",
        "CURRENT_SENSOR": "Current Sensor",
        "ENERGY_METER": "Energy Meter",
        "I_O_MODULE": "I/O module",
        "INS_S_H": "INS-S/H",
        "MODBUS": "Modbus",
        "SCU200": "SCU200",
        "METER_W_MBUS": "Meter WMBus",
        "METER_LINKY": "Meter Linky",
        "METER_P1": "Meter P1",
        "THIRD_PARTY_RTU": "Third Party RTU",
        "THIRD_PARTY_TCP": "Third Party TCP",
        "TRMS_A": "TRMS [A]",
        "AC_A": "AC [A]",
        "DC_A": "DC [A]",
        "ACTIVE_POWER_TOTAL_W": "Active power total [W]",
        "ACTIVE_ENERGY_TOTAL_WH": "Active energy total [kWh]",
        "Groups": "Groups",
        "Delete Gateway": "Delete Gateway",
        "N. Of alarms to be checked": "N. Of alarms to be checked",
        "N. Of automations to be checked": "N. Of automations to be checked"
      }
    }
  },
  "asset_management": {
    "Asset Management": "Asset Management",
    "Devices": "Devices",
    "Groups": "Groups",
    "Add Device": "Add Device",
    "New Group": "New Group",
    "You are managing a total of {tot} devices, of which {connected} are «connected», {offline} «offline», {noCommunication} with no communication": "You are managing a total of {{tot}} devices, of which {{connected}} are «connected», {{offline}} «offline», {{noCommunication}} with no communication",
    "You have a total of {tot} groups configured": "You have a total of {{tot}} groups configured",
    "tabs": {
      "devices": {
        "Offline": "Offline",
        "Okay": "Okay",
        "Needs intervention": "Needs intervention",
        "Name": "Name",
        "Status": "Status",
        "Category": "Category",
        "Group": "Group",
        "Property": "Property",
        "Device Name": "Device Name",
        "Communication Protocol": "Communication Protocol",
        "Power": "Power",
        "Temperature": "Temperature",
        "Asset not found": "Asset not found",
        "n/a": "n/a",
        "Manufacturer": "Manufacturer",
        "Model": "Model",
        "S/N": "S/N",
        "Most Recent Events": "Most Recent Events",
        "State": "State",
        "Last Update": "Last Update",
        "Condition": "Condition",
        "see all events": "see all events",
        "Auxiliary Contact": "Auxiliary Contact",
        "CURRENT_SENSOR": "Current Sensor",
        "ENERGY_METER": "Energy Meter",
        "I_O_MODULE": "I/O module",
        "INS_S_H": "INS-S/H",
        "MODBUS": "Modbus",
        "SCU200": "SCU200",
        "METER_W_MBUS": "Meter WMBus",
        "METER_LINKY": "Meter Linky",
        "METER_P1": "Meter P1",
        "THIRD_PARTY_RTU": "Third Party RTU",
        "THIRD_PARTY_TCP": "Third Party TCP",
        "TRMS_A": "TRMS [A]",
        "AC_A": "AC [A]",
        "DC_A": "DC [A]",
        "ACTIVE_POWER_TOTAL_W": "Active power total [W]",
        "ACTIVE_ENERGY_TOTAL_WH": "Active energy total [kWh]",
        "Meter Linky": "Meter Linky",
        "Meter P1": "Meter P1",
        "Third Party RTU": "Third Party RTU",
        "Third Party TCP": "Third Party TCP",
        "asset_details": {
          "Status": "Status",
          "Last update": "Last update",
          "Last update by": "Last update by",
          "Condition": "Condition",
          "Offline": "Offline",
          "Okay": "Okay",
          "Needs intervention": "Needs intervention",
          "Current status": "Current status",
          "Device details": "Device details",
          "Device control": "Device control",
          "Device firmware": "Device firmware",
          "Latest Firmware Update": "Latest Firmware Update",
          "Current Firmware": "Current Firmware",
          "Updating firmware...": "Updating firmware...",
          "New FW update available": "New FW update available",
          "Updated to the latest firmware": "Updated to the latest firmware",
          "Update firmware": "Update firmware",
          "On": "On",
          "Off": "Off",
          "CLOSED": "Closed",
          "OPEN": "Open",
          "CURRENT_SENSOR": "Current Sensor",
          "ENERGY_METER": "Energy Meter",
          "I_O_MODULE": "I/O module",
          "INS_S_H": "INS-S/H",
          "MODBUS": "Modbus",
          "SCU200": "SCU200",
          "METER_W_MBUS": "Meter WMBus",
          "METER_LINKY": "Meter Linky",
          "METER_P1": "Meter P1",
          "THIRD_PARTY_RTU": "Third Party RTU",
          "THIRD_PARTY_TCP": "Third Party TCP",
          "TRMS_A": "TRMS [A]",
          "AC_A": "AC [A]",
          "DC_A": "DC [A]",
          "ACTIVE_POWER_TOTAL_W": "Active power total [W]",
          "ACTIVE_ENERGY_TOTAL_WH": "Active energy total [kWh]",
          "Current Consumption": "Today's Average Consumption",
          "Highest Peak load current month": "Highest Consumption current month",
          "Average Monthly consumption": "Average Monthly consumption",
          "Total monthly cost": "Total Monthly Costs",
          "Name": "Name",
          "Manufacturer": "Manufacturer",
          "Model": "Model",
          "Serial Number": "Serial Number",
          "Service Contract": "Service Contract",
          "Installation Date": "Installation Date",
          "Location": "Location",
          "Coordinates": "Coordinates",
          "Power": "Power",
          "Charging speed": "Charging speed",
          "Back to devices": "Back to devices",
          "Export history": "Export history",
          "From": "From",
          "To": "To",
          "Generate report": "Generate report",
          "Low": "Low",
          "High": "High",
          "cancel": "cancel",
          "Apply": "Apply",
          "File generated successfully": "File generated successfully",
          "An error occurred while generating export file": "An error occurred while generating export file",
          "Edit device": "Edit device",
          "Save": "Save",
          "Latitude": "Latitude",
          "Longitude": "Longitude",
          "Device details updated": "Device details updated",
          "An error occurred while updating device details": "An error occurred while updating device details",
          "User": "User",
          "Groups": "Groups",
          "Automations": "Automations",
          "Alarms": "Alarms",
          "Port_1_State": "Port 1 Status",
          "Port_2_State": "Port 2 Status",
          "Port_3_State": "Port 3 Status",
          "Port_4_State": "Port 4 Status",
          "TripStatus": "Trip Status",
          "MCBTemperature": "MCB Temperature"
        }
      },
      "groups": {
        "Name": "Name",
        "Multiple properties": "Multiple properties",
        "Consumption": "Consumption",
        "Property": "Property",
        "Description": "Description",
        "cancel": "cancel",
        "Create": "Create",
        "New Group": "New Group",
        "Search" : "Search...",
        "Preview": "Preview",
        "Assets": "Assets",
        "Select at least one asset": "Select at least one asset",
        "{name} was created successfully": "{{name}} was created successfully",
        "An error occurred while creating {name}": "An error occurred while creating {{name}}",
        "{name} was updated successfully": "{{name}} was updated successfully",
        "An error occurred while updating {name}": "An error occurred while updating {{name}}",
        "Save": "Save",
        "Are you sure you want to remove group": "Are you sure you want to remove group",
        "Group removed successfully": "Group removed successfully",
        "Remove": "Remove",
        "Edit Group": "Edit Group",
        "Remove Group": "Remove Group"
      }
    }
  },
  "controls": {
    "Controls": "Controls",
    "You have no automations configured yet": "You have no automations configured yet",
    "You have a total of {tot} devices to be controlled": "You have a total of {{tot}} devices to be controlled",
    "You have a total of {tot} automations configured. In the last 5 days, {lastRan} have run and {failed} were not possible to be executed": "You have a total of {{tot}} automations configured. In the last 5 days, {{lastRan}} have run and {{failed}} were not possible to be executed",
    "Manual Control": "Manual Control",
    "Automations": "Automations",
    "New Automation": "New Automation",
    "tabs": {
      "manual_control": {
        "Status": "",
        "Offline": "Offline",
        "Connected": "Connected",
        "Needs intervention": "Needs intervention",
        "Device Name": "Device Name",
        "Device Category": "Device Category",
        "Group": "Group",
        "Name": "Name",
        "Off/On": "Off/On",
        "Action": "Action",
        "Temperature": "Temperature",
        "CURRENT_SENSOR": "Current Sensor",
        "ENERGY_METER": "Energy Meter",
        "I_O_MODULE": "I/O module",
        "INS_S_H": "INS-S/H",
        "MODBUS": "Modbus",
        "SCU200": "SCU200",
        "METER_W_MBUS": "Meter WMBus",
        "METER_LINKY": "Meter Linky",
        "METER_P1": "Meter P1",
        "THIRD_PARTY_RTU": "Third Party RTU",
        "THIRD_PARTY_TCP": "Third Party TCP",
        "Charging Speed": "Charging Speed",
        "Are you sure that you want to change the status from {fromStatus} to {toStatus} of the": "Are you sure that you want to change the status from {{fromStatus}} to {{toStatus}} of the",
        "cancel": "cancel",
        "Turn {toStatus}": "Turn {{toStatus}}",
        "{deviceName} was turned {devicePowerStatus} successfully": "{{deviceName}} was turned {{devicePowerStatus}} successfully"
      },
      "automations": {
        "New Automation": "New Automation",
        "Edit Automation": "Edit Automation",
        "cancel": "cancel",
        "Create": "Create",
        "Save": "Save",
        "Next": "Next",
        "Back": "back",
        "Apply": "Apply",
        "Trigger": "Trigger",
        "On selected period": "On selected period",
        "Start date": "Start date",
        "End date": "End date",
        "Automation Name": "Automation Name",
        "Name": "Name",
        "Conditions": "Conditions",
        "Type": "Type",
        "Select the type of asset you would like to create an automation for": "Select the type of asset you would like to create an automation for",
        "Properties": "Properties",
        "Groups": "Groups",
        "Devices": "Devices",
        "Search": "Search",
        "Device": "Device",
        "Event Type": "Event Type",
        "Measure": "Measure",
        "Threshold": "Threshold",
        "Add another condition": "Add another condition",
        "Time delay (seconds)": "Time delay (seconds)",
        "Delay": "Delay",
        "Alarm": "Alarm",
        "Send event": "Send event",
        "Enabled": "Enabled",
        "Device Details": "Device Details",
        "Port": "Port",
        "Action": "Action",
        "Please fill in all required fields before moving forward": "Please fill in all required fields before moving forward",
        "You have to exit edit mode to proceed": "You have to exit edit mode to proceed",
        "Please save or cancel changes to current condition before adding a new one": "Please save or cancel changes to current condition before adding a new one",
        "Please save or cancel changes to current condition before editing another one": "Please save or cancel changes to current condition before editing another one",
        "Please save or cancel changes to current condition before removing another one": "Please save or cancel changes to current condition before removing another one",
        "Are you sure you want to remove condition": "Are you sure you want to remove condition",
        "Please remove duplicated conditions before proceeding": "Please remove duplicated conditions before proceeding",
        "Remove": "Remove",
        "No": "No",
        "Yes": "Yes",
        "WARNING: This action will result in losing any unsaved changes.<br>Do you want to save changes before continuing": "WARNING: This action will result in losing any unsaved changes.<br>Do you want to save changes before continuing",
        "Please save or cancel changes to current condition before leaving this step": "Please save or cancel changes to current condition before leaving this step",
        "{name} was created successfully": "{{name}} was created successfully",
        "An error occurred while creating {name}": "An error occurred while creating {{name}}",
        "{name} was updated successfully": "{{name}} was updated successfully",
        "An error occurred while updating {name}": "An error occurred while updating {{name}}",
        "Configured": "Configured",
        "Logs": "Logs",
        "This field is required": "This field is required",
        "Invalid date": "Invalid date",
        "OPEN": "Open",
        "CLOSE": "Close",
        "tabs": {
          "configured": {
            "Automation Name": "Automation Name",
            "Show with alarm only": "Show with alarm only",
            "Show enabled automations only": "Show enabled automations only",
            "Yes": "Yes",
            "No": "No",
            "Name": "Name",
            "When": "When",
            "If": "If",
            "Then": "Then",
            "Alarm": "Alarm",
            "Last update": "Last update",
            "Failed": "Failed",
            "years ago": "years ago",
            "months ago": "months ago",
            "days ago": "days ago",
            "hours ago": "hours ago",
            "minutes ago": "minutes ago",
            "seconds ago": "seconds ago",
            "just now": "just now",
            "Enabled": "Enabled",
            "Properties": "Properties",
            "Groups": "Groups",
            "Devices": "Devices",
            "Conditions": "Conditions",
            "New Automation - IF": "New Automation - IF",
            "Type": "Type",
            "Device": "Device",
            "Event Type": "Event Type",
            "Measure": "Measure",
            "Threshold": "Threshold",
            "Add another condition": "Add another condition",
            "Time delay (seconds)": "Time delay (seconds)",
            "Delay": "Delay",
            "Send event": "Send event",
            "New Automation - Then": "New Automation - Then",
            "Device Details": "Device Details",
            "Port": "Port",
            "Action": "Action",
            "cancel": "cancel",
            "Create": "Create",
            "Back": "back",
            "Are you sure that you want to {action}": "Are you sure that you want to {{action}}",
            "Enable": "Enable",
            "Disable": "Disable",
            "Set in alarm": "Set in alarm",
            "set in alarm": "set in alarm",
            "disable": "disable",
            "enable": "enable",
            "remove": "remove",
            "enabled": "enabled",
            "disabled": "disabled",
            "enabled_other": "enabled",
            "disabled_other": "disabled",
            "enabling": "enabling",
            "disabling": "disabling",
            "Remove": "Remove",
            "all selected items": "all selected items",
            "Automation {action} successfully": "Automation {{action}} successfully",
            "An error occurred while {action} automation": "An error occurred while {{action}} automation",
            "Selected automations are already {status}": "Selected automations are already {{status}}",
            "Selected automations are already in alarm status": "Selected automations are already in alarm status",
            "Automation deleted successfully": "Automation deleted successfully",
            "An error occurred while deleting the automation": "An error occurred while deleting the automation",
            "Automation set successfully in alarm": "Automation set successfully in alarm",
            "An error occurred while setting automation in alarm": "An error occurred while setting automation in alarm",
            "Group": "Group",
            "Property": "Property",
            "SYSTEM": "System",
            "CROSS_UP": "Cross Up",
            "CROSS_DOWN": "Cross Down",
            "STATUS_CHANGE": "Status Change",
            "COMMUNICATION_FAILURE": "Communication Failure",
            "COMMUNICATION_RESTORE": "Communication Restore",
            "STATUS_CHANGE_TO_CLOSED": "Status Change To Closed",
            "STATUS_CHANGE_TO_OPEN": "Status Change To Open",
            "AUTOMATION_SUCCESS": "Automation Success",
            "AUTOMATION_FAILURE": "Automation Failure",
            "VALUE_MATCH": "Value Match",
            "STATUS_CHANGE_TO_ON": "Status Change To On",
            "STATUS_CHANGE_TO_OFF": "Status Change To Off",
            "VALUE_CHANGE": "Value Change",
            "CURRENT_SENSOR": "Current Sensor",
            "ENERGY_METER": "Energy Meter",
            "I_O_MODULE": "I/O module",
            "INS_S_H": "INS-S/H",
            "MODBUS": "Modbus",
            "SCU200": "SCU200",
            "METER_W_MBUS": "Meter WMBus",
            "METER_LINKY": "Meter Linky",
            "METER_P1": "Meter P1",
            "THIRD_PARTY_RTU": "Third Party RTU",
            "THIRD_PARTY_TCP": "Third Party TCP",
            "TRMS_A": "TRMS [A]",
            "AC_A": "AC [A]",
            "DC_A": "DC [A]",
            "ACTIVE_POWER_TOTAL_W": "Active power total [W]",
            "ACTIVE_ENERGY_TOTAL_WH": "Active energy total [kWh]"
          },
          "logs": {
            "Date": "Date",
            "cancel": "cancel",
            "Apply": "Apply",
            "Export": "Export",
            "Start date": "Start date",
            "End date": "End date",
            "Name": "Name",
            "When": "When",
            "If": "If",
            "Then": "Then",
            "Automation time": "Automation time",
            "Alarm": "Alarm",
            "Properties": "Properties",
            "Groups": "Groups",
            "Devices": "Devices",
            "Status": "Status",
            "Successfully": "Successfully",
            "Failure": "Failure",
            "Yes": "Yes",
            "No": "No",
            "File exported successfully": "File exported successfully",
            "An error occurred while exporting file": "An error occurred while exporting file",
            "Group": "Group",
            "Property": "Property",
            "Device": "Device",
            "CROSS_UP": "Cross Up",
            "CROSS_DOWN": "Cross Down",
            "STATUS_CHANGE": "Status Change",
            "COMMUNICATION_FAILURE": "Communication Failure",
            "COMMUNICATION_RESTORE": "Communication Restore",
            "STATUS_CHANGE_TO_CLOSED": "Status Change To Closed",
            "STATUS_CHANGE_TO_OPEN": "Status Change To Open",
            "AUTOMATION_SUCCESS": "Automation Success",
            "AUTOMATION_FAILURE": "Automation Failure",
            "VALUE_MATCH": "Value Match",
            "STATUS_CHANGE_TO_ON": "Status Change To On",
            "STATUS_CHANGE_TO_OFF": "Status Change To Off",
            "VALUE_CHANGE": "Value Change",
            "OPEN": "Open",
            "CLOSE": "Close",
            "TRMS_A": "TRMS [A]",
            "AC_A": "AC [A]",
            "DC_A": "DC [A]",
            "ACTIVE_POWER_TOTAL_W": "Active power total [W]",
            "ACTIVE_ENERGY_TOTAL_WH": "Active energy total [kWh]"
          }
        }
      }
    }
  },
  "dashboards": {
    "You have {count} unread alerts_one": "You have <a href='alarms/list' class='underline text-blue-600'>{{count}} active alert</a>.",
    "You have {count} unread alerts_other": "You have <a href='alarms/list' class='underline text-blue-600'>{{count}} active alerts</a>.",
    "All installation are running smoothly.": "All installation are running smoothly.",
    "No alarms require your attention.": "No alarms require your attention.",
    "All installations are running smoothly.": "All installations are running smoothly.",
    "Create new dashboard": "Create new dashboard",
    "Stop editing": "Stop editing",
    "Add widget": "Add widget",
    "Dashboard deleted successfully": "Dashboard deleted successfully",
    "An error occurred while deleting the dashboard": "An error occurred while deleting the dashboard",
    "Are you sure you want to delete \"{name}\"?": "Are you sure you want to delete \"{{name}}\"?",
    "Delete dashboard": "Delete dashboard",
    "An error occurred while pinning the dashboard": "An error occurred while pinning the dashboard",
    "Export": "Export",
    "File generated successfully": "File generated successfully",
    "An error occurred while generating export file": "An error occurred while generating export file",
    "modal": {
      "Create": "Create",
      "cancel": "cancel",
      "Name": "Name",
      "The name of your new dashboard, this will also serve as the dashboard title": "The name of your new dashboard, this will also serve as the dashboard title",
      "An error occurred while creating the dashboard": "An error occurred while creating the dashboard",
      "Dashboard created successfully": "Dashboard created successfully",
      "Create Dashboard": "Create Dashboard",
      "Dashboard updated successfully": "Dashboard updated successfully",
      "An error occurred while updating the dashboard": "An error occurred while updating the dashboard",
      "Update Dashboard": "Update Dashboard",
      "Save": "Save"
    },
    "side_panel": {
      "New widget": "New widget",
      "Widget type": "Widget type",
      "Number": "Number",
      "No results found": "- No results found",
      "Search": "Search...",
      "Chart": "Chart",
      "Benchmark": "Benchmark",
      "Alarms/Events": "Alarms/Events",
      "Solar": "Solar",
      "Filter": "Filter",
      "Map": "Map",
      "Energy monitoring": "Energy monitoring",
      "Non-electrical parameters": "Non-electrical parameters",
      "Cost management": "Cost management",
      "Alarms monitoring": "Alarms monitoring",
      "Control": "Control",
      "Automations": "Automations",
      "Data analysis": "Data analysis",
      "Asset monitoring": "Asset monitoring",
      "Sustainability": "Sustainability",
      "Properties": "Properties",
      "Widget for metrics or instantaneous values.": "Widget for metrics or instantaneous values.",
      "Widget for visualizing a key parameter.": "Widget for visualizing a key parameter.",
      "Widget for benchmark comparisons even with external sources.": "Widget for benchmark comparisons even with external sources.",
      "Widget for visualizing events and alarms.": "Widget for visualizing events and alarms.",
      "Widget for visualizing solar generation.": "Widget for visualizing solar generation.",
      "Widget for enabling quick and frequent manual control actions.": "Widget for enabling quick and frequent manual control actions.",
      "Widget for filtering the dashboard details.": "Widget for filtering the dashboard details.",
      "Widget for geolocation visualization.": "Widget for geolocation visualization.",
      "{type} widget": "{{type}} widget",
      "Widget selection": "Widget selection",
      "An error occurred while creating the widget": "An error occurred while creating the widget",
      "Widget created successfully": "Widget created successfully",
      "Widget duplicated successfully": "Widget duplicated successfully",
      "Create": "Create",
      "Update": "Update",
      "cancel": "cancel",
      "Metric": "Metric",
      "currentTrms": "TRMS",
      "currentAc": "AC",
      "currentDc": "DC",
      "activePowerTotal": "Active power",
      "activeEnergyTotal": "Active energy",
      "Metric type": "Metric type",
      "Assets": "Assets",
      "Metric details": "Metric details",
      "Preview": "Preview",
      "An error occurred while updating the widget": "An error occurred while updating the widget",
      "Widget updated successfully": "Widget updated successfully",
      "Save": "Save",
      "Electrical values": "Electrical values",
      "Data presentation of general electrical values": "Displays general electrical values for properties, groups, or devices.",
      "Title": "Title",
      "Property / Group": "Property / Group",
      "Groups": "Groups",
      "No matches found": "No matches found",
      "Type": "Type",
      "Auxiliary Contact": "Auxiliary Contact",
      "Meter WMbus": "Meter WMbus",
      "Meter Linky": "Meter Linky",
      "Meter P1": "Meter P1",
      "Third Party RTU": "Third Party RTU",
      "Third Party TCP": "Third Party TCP",
      "Devices": "Devices",
      "Display": "Display",
      "Chart (linear)": "Chart (linear)",
      "Chart (column)": "Chart (column)",
      "Chart (donut)": "Chart (donut)",
      "Table": "Table",
      "Gauge": "Gauge",
      "Min": "Min",
      "Max": "Max",
      "Target (min)": "Target (min)",
      "Target (max)": "Target (max)",
      "Y axis": "Y axis",
      "Data presentation of values from category \"Energy values\"": "Displays energy values for properties, groups, or devices.",
      "Energy values": "Energy values",
      "Power quality values": "Power quality values",
      "Data presentation of values from category \"Power Quality Values\"": "Displays power quality values for properties, groups, or devices.",
      "Custom values": "Custom values",
      "Data presentation of values from other categories": "Displays specific device parameters for properties, groups, or devices.",
      "Cost benchmark": "Cost benchmark",
      "Cost comparison data between properties, groups or devices": "Compares costs between properties, groups, or devices.",
      "Device": "Device",
      "Group": "Group",
      "Property": "Property",
      "Criteria": "Criteria",
      "Date": "Date",
      "Timeframe": "Timeframe",
      "Today": "Today",
      "Yesterday": "Yesterday",
      "Last week": "Last week",
      "Last month": "Last month",
      "Last year": "Last year",
      "Specific date": "Specific date",
      "Cost details per property or group": "Provides a cost breakdown for properties or groups within a specific timeframe.",
      "Energy cost breakdown": "Energy cost breakdown",
      "Max / Min values": "Max / Min values",
      "Data visualization of Max, Min and Avg values for established device conditions": "Displays maximum, minimum, and average values for properties, groups, or devices within a specific timeframe.",
      "Max / Min": "Max / Min",
      "Energy consumption": "Energy consumption",
      "Data presentation of \"Energy values\" between different types of devices": "Displays energy consumption values for properties, groups, or devices.",
      "Data presentation of Water / Gas data": "Displays the configured setup for gas or water consumption details.",
      "Water / Gas": "Water / Gas",
      "Contracts & Tariffs": "Contracts & Tariffs",
      "Data presentation of contracts & tariffs values": "Displays the current configuration of existing contracts and tariffs.",
      "Contract": "Contract",
      "Tariff": "Tariff",
      "Data presentation of number of alarms to be acknowledged": "Displays the number of alarms to be acknowledged per property.",
      "N. of alarms": "N. of alarms",
      "Data presentation of alarms triggered": "Monitors the alarms that have been triggered per property and timeframe.",
      "Alarm log": "Alarm log",
      "Columns": "Columns",
      "Data presentation of automations that have occurred": "Monitors the automations that have run per property and timeframe.",
      "Automations log": "Automations log",
      "Visualization of the current devices status": "Visualizes the current status of devices.",
      "Device status": "Device status",
      "Online events": "Online events",
      "Data presentation of online events": "Monitors device status changes for a specific timeframe.",
      "CO2 Emissions": "CO2 Emissions",
      "Measure the impact of your overall consumption": "Tracks the overall consumption impact.",
      "Visualization": "Visualization",
      "Average": "Average",
      "Single": "Single",
      "Conversion factor": "Conversion factor",
      "Targets": "Targets",
      "Select at least one property": "Select at least one property",
      "Widget for customizable text options": "Displays the configured setup for gas or water consumption details.",
      "Text": "Text",
      "Geolocation Visualization": "Provides geolocation visualization of the configured properties.",
      "Location": "Location",
      "Actual vs Target Values": "Actual vs Target Values",
      "Comparison of real values vs targeted ones": "Compares real values to targeted ones.",
      "Metrics": "Metrics",
      "Metrics Target": "Metrics Target",
      "Metrics Threshold": "Metrics Threshold",
      "Select at least one metric": "Select at least one metric",
      "If Metric greater than Metric Target is Good": "Metric greater than Metric Target is Good",
      "If Metric lower than Metric Target is Good": "Metric lower than Metric Target is Good",
      "N/A": "N/A",
      "KPIs calculation based on existing parameters": "Calculates KPIs based on existing parameters.",
      "KPIs Calculation": "KPIs Calculation",
      "Operation": "Operation",
      "Add (+)": "Add (+)",
      "Subtract (-)": "Subtract (-)",
      "Multiply (*)": "Multiply (*)",
      "Divide (/)": "Divide (/)",
      "Against": "Against",
      "Constant": "Constant",
      "Other metric": "Other metric",
      "This field is required": "This field is required",
      "Please fill all required fields": "Please fill all required fields",
      "Are you sure you want to remove device": "Are you sure you want to remove device",
      "You cannot delete device": "You cannot delete device",
      "To delete the device, you must first remove the following items.": "To delete the device, you must first remove the following items.",
      "Dashboard": "Dashboard",
      "Widgets": "Widgets",
      "Dashboards":"Dashboards",
      "Alarms":"Alarms",
      "Contracts":"Contracts",
      "Attention":"Attention",
      "Maximum 10 devices can be selected": "Maximum 10 devices can be selected"
    },
    "currentTrms": "TRMS",
    "currentAc": "AC",
    "currentDc": "DC",
    "activePowerTotal": "Active power",
    "activeEnergyTotal": "Active energy",
    "Do you want to delete this widget?": "Do you want to delete this widget?",
    "Warning": "Warning",
    "An error occurred while deleting the widget": "An error occurred while deleting the widget",
    "Widget deleted": "Widget deleted",
    "On": "On",
    "Off": "Off",
    "Refresh rate": "Refresh rate",
    "Refresh rate was updated successfully": "Refresh rate was updated successfully",
    "Minutes {{minutes}}": "{{minutes}} Minutes",
    "max_min_values": {
      "Min": "Min",
      "Max": "Max",
      "Avg": "Avg"
    },
    "contracts_and_tariffs": {
      "Cost": "Cost",
      "Total cost of contract divided by tariffs:": "Total cost of contract divided by tariffs:",
      "Name": "Name",
      "Type": "Type",
      "Tag": "Tag",
      "Devices": "Devices",
      "Tariffs": "Tariffs",
      "Total cost": "Total cost",
      "Usage": "Usage",
      "You don't have permission to view this property or group": "You don't have permission to view this property or group"
    },
    "alarm_log": {
      "Name": "Name",
      "State": "State",
      "Condition": "Condition",
      "Time": "Time",
      "Property": "Property",
      "Groups": "Groups",
      "NAME": "Name",
      "STATE": "State",
      "CONDITION": "Condition",
      "TIME": "Time",
      "PROPERTY": "Property",
      "GROUPS": "Groups"
    },
    "automations_log": {
      "Name": "Name",
      "Conditions (WHEN/IF/THEN)": "Conditions (WHEN/IF/THEN)",
      "Time": "Time",
      "Property": "Property",
      "Groups": "Groups"
    },
    "online_events": {
      "Name": "Name",
      "Device": "Device",
      "Category": "Category",
      "Status": "Status",
      "Date and Time": "Date and Time"
    },
    "list_with_target_widget": {
      "Selected properties": "Selected properties",
      "Name": "Name",
      "Value": "Value",
      "CO2 emissions": "CO<sub>2</sub> emissions",
      "Target": "Target",
      "g CO2/kWh": "g CO<sub>2</sub>/kWh"
    },
    "number_and_list_widget": {
      "Number of alarms to be acknowledged": "Number of alarms to be acknowledged",
      "Properties": "Properties"
    },
    "DEVICE_NAME": "Device name",
    "NAME": "Name",
    "STATE": "State",
    "CONDITION": "Condition",
    "CONDITIONS": "Conditions",
    "TIME": "Time",
    "PROPERTY": "Property",
    "GROUPS": "Groups",
    "DATEANDTIME": "Date and Time",
    "You don't have permission to view this property or group": "You don't have permission to view this property or group"
  },
  "reports": {
    "Reports": "Reports",
    "You have a total of {tot} reports available.": "You have a total of {{tot}} reports available.",
    "New Report": "New Report",
    "{name} was created successfully": "{{name}} was created/queued successfully",
    "An error occurred while creating {name}": "An error occurred while creating {{name}}",
    "Name": "Name",
    "Date": "Date",
    "Author": "Author",
    "Category": "Category",
    "Format": "Format",
    "Open": "Open",
    "Download": "Download",
    "cancel": "cancel",
    "Create": "Create",
    "Apply": "Apply",
    "Report Name": "Report Name",
    "Template": "Template",
    "Interval": "Interval",
    "From": "From",
    "To": "To",
    "Start date": "Start date",
    "End date": "End date",
    "Properties": "Properties",
    "Search": "Search",
    "This field is required": "This field is required",
    "An error occurred while exporting file": "An error occurred while exporting file",
    "File exported successfully": "File exported successfully",
    "Invalid date": "Invalid date",
    "New Report Template": "New Report Template",
    "Edit Report Template": "Edit Report Template",
    "Report Template Name": "Report Template Name",
    "Description": "Description",
    "Components": "Components",
    "Clone": "Clone",
    "An error occurred while saving {name}": "An error occurred while saving {{name}}",
    "{name} saved successfully": "{{name}} saved successfully",
    "Save": "Save",
    "Time range: {fromDate} - {toDate}": "Time range: {{fromDate}} - {{toDate}}",
    "Printing instructions": "Printing instructions",
    "You will be prompted to print this page containing the report. Make sure you remove margins and include background graphics to properly render the document": "You will be prompted to print this page containing the report. Make sure you remove margins and include background graphics to properly render the document",
    "Print": "Print",
    "Delete Report Template": "Delete Report Template",
    "Are you sure you want to delete {name}": "Are you sure you want to delete {{name}}",
    "Delete": "Delete",
    "Are you sure you want to remove report": "Are you sure you want to remove report",
    "An error occurred while removing report": "An error occurred while removing report",
    "Report removed successfully": "Report removed successfully",
    "ESG report": "ESG Report",
    "Not all values for the properties are completed": "Not all values for the properties are completed",
    "Attention": "Attention",
    "Processing": "Processing",
    "The report will be ready in a few minutes. You can come back to this page later to see it": "The report will be ready in a few minutes. You can come back to this page later to see it"
  },
  "settings": {
    "Settings": "Settings",
    "Account": "Account",
    "Notifications": "Notifications",
    "General": "General",
    "Users": "Users",
    "New User": "New User",
    "tabs": {
      "account": {
        "terms & conditions": "Terms & conditions",
        "privacy notice": "ABB S.p.A. processes personal data particularly to grant you access and contact you. Please find more detailed information including data privacy rights in the <a href='https://new.abb.com/privacy-notice/external-stakeholders' target='_blank' class='underline text-abb-primary hover:text-abb-primary/80'>Privacy Notice</a>.",
        "Profile Picture": "Profile Picture",
        "License": "License",
        "Account Details": "Account Details",
        "Upload/Change Your Profile": "Upload/Change Your Profile",
        "Upload Avatar": "Upload Avatar",
        "remove": "remove",
        "ID": "ID",
        "Assigned to": "Assigned to",
        "Type": "Type",
        "Commissioning Activation Date": "Commissioning Activation Date",
        "Free Trial Activation": "Free Trial Activation Date",
        "Current Status": "Current Status",
        "Expiration date": "Expiration date",
        "Under free trial period": "Under free trial period",
        "TDB": "To be determined",
        "Renew": "Renew",
        "Change License": "Change License",
        "Name": "Name",
        "Surname": "Surname",
        "Company / Legal Entity": "Company / Legal Entity",
        "Address": "Address",
        "Phone": "Phone",
        "Country": "Country",
        "City": "City",
        "Postal Code": "Postal Code",
        "Email Address": "Email Address",
        "Change Details": "Change Details",
        "Change Password": "Change Password",
        "Edit": "Edit",
        "cancel": "cancel",
        "Save": "Save",
        "Confirm": "Confirm",
        "Code for {attribute}": "Code for {{attribute}}",
        "Confirmation code was sent to {deliveryMedium}": "Confirmation code was sent to {{deliveryMedium}}",
        "Transfer Data": "Transfer Data",
        "Transfer License": "Transfer License",
        "Transfer owner license to": "Transfer owner license to",
        "Search": "Search",
        "This field is required": "This field is required",
        "Old password": "Old password",
        "New password": "New password",
        "Confirm new password": "Confirm new password",
        "Confirm new password does not match": "Confirm new password does not match",
        "Password updated successfully": "Password updated successfully",
        "An error occurred while updating password": "An error occurred while updating password",
        "An error occurred while updating user": "An error occurred while updating user",
        "An error occurred while transferring license to user {fullName}": "An error occurred while transferring license to user {{fullName}}",
        "Password must be at least 8 characters long": "Password must be at least 8 characters long",
        "Password must not exceed 256 characters": "Password must not exceed 256 characters",
        "Password must include uppercase and lowercase letters, a number, and a special character (e.g., !@#$%^&*())": "Password must include uppercase and lowercase letters, a number, and a special character (e.g., !@#$%^&*())",
        "License {id} transferred successfully to user {name} {surname}": "License {{id}} transferred successfully to user {{name}} {{surname}}"
      },
      "notifications": {
        "Notifications": "Notifications",
        "Specify how you would like to receive notifications": "Specify how you would like to receive notifications",
        "Email": "Email",
        "In-app / Push Notifications": "In-app / Push Notifications",
        "SMS": "SMS",
        "Critical events": "Critical events",
        "Information Events": "Information Events",
        "System Events": "System Events",
        "General information regarding the application (e.g. new upgrades, new functionalities, etc).": "General information regarding the application (e.g. new upgrades, new functionalities, etc.)",
        "Notifications linked to alarms, automations and critical connection issues.": "Notifications linked to alarms and critical connection issues.",
        "General informative messages linked to non-critical connection issues.": "General informative messages linked to non-critical connection issues."
      },
      "general": {
        "Region": "Region",
        "Language": "Language",
        "System": "System",
        "Country": "Country",
        "Timezone": "Timezone",
        "Currency": "Currency",
        "This field is required": "This field is required",
        "Change Region Settings": "Change Region Settings",
        "Edit": "Edit",
        "cancel": "cancel",
        "Save": "Save",
        "UI Aspect": "UI Aspect",
        "ABB": "ABB",
        "Custom": "Custom",
        "Theme color": "Theme color",
        "Text color": "Text color",
        "Logo": "Logo",
        "Background color": "Background color",
        "English": "English",
        "German": "German",
        "Italian": "Italian",
        "French": "French",
        "Spanish": "Spanish",
        "Version of the app": "Version of the app",
        "Version": "Version",
        "Latest SCU200 firmware": "Latest SCU200 firmware",
        "Fw": "Fw",
        "Current SCU200 firmware status": "Current SCU200 firmware status",
        "View details": "View details",
        "SCU200 firmware update": "SCU200 firmware update",
        "No data": "No data",
        "Updating": "Updating",
        "Update available": "Update available",
        "Updated": "Updated",
        "Update firmware": "Update firmware",
        "Please select a background color": "Please select a background color.",
        "Please select a theme color": "Please select a theme color.",
        "Please select a text color": "Please select a text color."
      },
      "users": {
        "Name": "Name",
        "Surname": "Surname",
        "Email": "Email",
        "Select Properties": "Select Properties",
        "Role": "Role",
        "Properties": "Properties",
        "Edit User": "Edit User",
        "Remove User": "Remove User",
        "New User": "New User",
        "Edit": "Edit",
        "cancel": "cancel",
        "Create": "Create",
        "Save": "Save",
        "Admin": "Admin",
        "Advanced / Power User": "Advanced / Power User",
        "View Only (Viewer)": "View Only (Viewer)",
        "Commissioner/Integrator": "Commissioner/Integrator",
        "This field is required": "This field is required",
        "Email is not valid (e.g., user@example.com)": "Email is not valid (e.g., user@example.com)",
        "Remove": "Remove",
        "Are you sure you want to remove user": "Are you sure you want to remove user",
        "{name} was created successfully": "{{name}} was created successfully",
        "{name} was updated successfully": "{{name}} was updated successfully",
        "An error occurred while creating {name}": "An error occurred while creating {{name}}",
        "An error occurred while updating {name}": "An error occurred while updating {{name}}",
        "User deleted successfully": "User deleted successfully",
        "An error occurred while deleting the user": "An error occurred while deleting the user",
        "This user cannot be deleted": "This user cannot be deleted",
        "An error occurred while checking user permissions": "An error occurred while checking user permissions",
        "Okay": "Okay",
        "End validity date": "End validity date",
        "Category": "Category",
        "Viewer": "Viewer",
        "Editing": "Editing"
      },
      "user-logs": {
        "User Logs": "User Logs",
        "User": "User",
        "Date": "Date",
        "Action": "Action",
        "Object": "Object",
        "id object": "id object",
        "object": {
          "DASHBOARD": "Dashboard",
          "PROPERTY": "Property",
          "USER": "User",
          "DEVICE": "Device",
          "ALARM": "Alarm",
          "AUTOMATION": "Automation",
          "REPORT": "Report",
          "GROUP": "Group",
          "CONTRACT": "Contract",
          "WIDGET": "Widget",
          "CONTROL": "Control",
          "REFRESH_DASHBOARD": "Refresh Dashboard",
          "LOGON": "Logon"
          },
        "action": {
          "CREATE": "Create",
          "UPDATE": "Update",
          "DELETE": "Delete",
          "DUPLICATE": "Duplicate",
          "LOGIN": "Login",
          "LOGOUT": "Logout"
        },
        "create": "Create",
        "update": "Update",
        "delete": "Delete",
        "Export CSV": "Export CSV",
        "Download": "Download"
      }
    }
  },
  "commons": {
    "No notifications to display": "No notifications to display",
    "Are you sure?": "Are you sure?",
    "cancel": "cancel",
    "Confirm": "Confirm",
    "My Account": "My Account",
    "Logout": "Logout",
    "My Sites' Accounts": "My Sites' Accounts",
    "An account with the given email or phone number already exists.": "An account with the given email or phone number already exists.",
    "We encountered an issue while trying to send the verification code. Please check your email or phone number and try again.": "We encountered an issue while trying to send the verification code. Please check your email or phone number and try again.",
    "The code you entered is not valid. Please double-check the code and try again.": "The code you entered is not valid. Please double-check the code and try again.",
    "An error occurred with the Cognito Identity Provider service.": "An error occurred with the Cognito Identity Provider service.",
    "Concurrent modification of the resource occurred.": "Concurrent modification of the resource occurred.",
    "The provider is already linked to a user.": "The provider is already linked to a user.",
    "Failed to enable software token MFA.": "Failed to enable software token MFA.",
    "The verification code you entered has expired. Please request a new code and try again.": "The verification code you entered has expired. Please request a new code and try again.",
    "You do not have permission to perform this action.": "You do not have permission to perform this action.",
    "This group already exists.": "This group already exists.",
    "An internal error has occurred, please try again.": "An internal error has occurred, please try again.",
    "The email role access policy is not valid.": "The email role access policy is not valid.",
    "Invalid response from the Lambda function.": "Invalid response from the Lambda function.",
    "The specified OAuth flow is not valid.": "The specified OAuth flow is not valid.",
    "Invalid parameter: Email format is incorrect.": "Invalid parameter: Email format is incorrect.",
    "Invalid parameter: Phone number format is incorrect. Please make sure to include your country code.": "Invalid parameter: Phone number format is incorrect. Please make sure to include your country code.",
    "Invalid parameter: Company must be 3-50 characters long.": "Invalid parameter: Company must be 3-50 characters long.",
    "Invalid parameter: Please check your input.": "Invalid parameter: Please check your input.",
    "Invalid password: Password must be 8-256 characters long.": "Invalid password: Password must be 8-256 characters long.",
    "Invalid password: Password must include uppercase letters.": "Invalid password: Password must include uppercase letters.",
    "Invalid password: Password must include lowercase letters.": "Invalid password: Password must include lowercase letters.",
    "Invalid password: Password must include a number.": "Invalid password: Password must include a number.",
    "Invalid password: Password must include a special character (e.g., !@#$%^&*()).": "Invalid password: Password must include a special character (e.g., !@#$%^&*()).",
    "Invalid password: Password must be 8-256 characters long, include uppercase and lowercase letters, a number, and a special character.": "Invalid password: Password must be 8-256 characters long, include uppercase and lowercase letters, a number, and a special character.",
    "The SMS role access policy is not valid.": "The SMS role access policy is not valid.",
    "The SMS role trust relationship is not valid.": "The SMS role trust relationship is not valid.",
    "The user pool configuration is not valid.": "The user pool configuration is not valid.",
    "Attempt limit exceeded, please try after some time.": "Attempt limit exceeded, please try after some time.",
    "The specified MFA method is not found.": "The specified MFA method is not found.",
    "Incorrect username or password.": "Incorrect username or password.",
    "This password was used recently. Please choose a different password.": "This password was used recently. Please choose a different password.",
    "Password reset is required.": "Password reset is required.",
    "A precondition for the request is not met.": "A precondition for the request is not met.",
    "The requested resource was not found.": "The requested resource was not found.",
    "Risk configuration exception occurred.": "Risk configuration exception occurred.",
    "The specified scope does not exist.": "The specified scope does not exist.",
    "The software token MFA is not found.": "The software token MFA is not found.",
    "Too many failed attempts, please try again later.": "Too many failed attempts, please try again later.",
    "Too many requests, please try again later.": "Too many requests, please try again later.",
    "The request is not authorized. This can happen due to an invalid access token.": "The request is not authorized. This can happen due to an invalid access token.",
    "An unexpected error occurred with the Lambda function.": "An unexpected error occurred with the Lambda function.",
    "The specified identity provider is not supported.": "The specified identity provider is not supported.",
    "The operation is not supported.": "The operation is not supported.",
    "The specified token type is not supported.": "The specified token type is not supported.",
    "The user is in an unsupported state.": "The user is in an unsupported state.",
    "A user import job is in progress.": "A user import job is in progress.",
    "The provided password does not meet the requirements.": "The provided password does not meet the requirements.",
    "User is not confirmed.": "User is not confirmed.",
    "User does not exist.": "User does not exist.",
    "The user pool add-on is not enabled.": "The user pool add-on is not enabled.",
    "The user pool tagging operation failed.": "The user pool tagging operation failed.",
    "An account with the given email already exists.": "An account with the given email already exists.",
    "There is already a signed in user.": "There is already a signed in user.",
    "{count} items selected_one": "{{count}} item selected",
    "{count} items selected_other": "{{count}} items selected",
    "Edit": "Edit",
    "Enable": "Enable",
    "Disable": "Disable",
    "Delete": "Delete",
    "Alarm": "Alarm",
    "Clone": "Clone",
    "Warning": "Warning",
    "Unauthorized Access": "Unauthorized Access",
    "You do not have permission to view this page": "You do not have permission to view this page",
    "Return to Home": "Return to Home",
    "An error occurred": "An error occurred"
  },
  "login": {
    "Don’t have an account? Sign-up": "Don’t have an account? Sign-up",
    "Reset mfa": "Reset mfa",
    "Forgot password": "Forgot password",
    "Reset Password": "Reset Password",
    "Back": "back",
    "Username": "Username",
    "Confirmation Code": "Confirmation Code",
    "Confirmation code was sent by {deliveryMedium} to {deliveryDestination}": "Confirmation code was sent by {{deliveryMedium}} to {{deliveryDestination}}",
    "Password has been successfully reset: you can now log in with your new password": "Password has been successfully reset: you can now log in with your new password",
    "New Password": "New Password",
    "Log in": "Log in",
    "Login": "Login",
    "Email address": "Email address",
    "Password": "Password",
    "This field is required": "This field is required",
    "Email is not valid (e.g., user@example.com)": "Email is not valid (e.g., user@example.com)",
    "Password is not valid": "Password is not valid",
    "Password must be at least 8 characters long": "Password must be at least 8 characters long",
    "Password must not exceed 256 characters": "Password must not exceed 256 characters",
    "Password must include uppercase and lowercase letters, a number, and a special character (e.g., !@#$%^&*())": "Password must include uppercase and lowercase letters, a number, and a special character (e.g., !@#$%^&*())",
    "Confirm": "Confirm",
    "Code": "Code",
    "Code is not valid": "Code is not valid",
    "Code has expired": "Code has expired",
    "Confirmation code is not valid": "Confirmation code is not valid",
    "Confirmation code has expired": "Confirmation code has expired",
    "Scan this QR code with your authenticator app to configure Two-Factor Authentication": "Scan this QR code using any authenticator app (e.g., Microsoft Authenticator, Google Authenticator) to set up Two-Factor Authentication for your account. The app you choose will serve as your primary method for securely accessing the applicationn",
    "Please open your authenticator app and enter the verification code to continue": "Please open your authenticator app and enter the verification code to continue",
    "Please open your inbox and enter the verification code you received to continue": "Please open your inbox and enter the verification code you received to continue",
    "OTP sent, please check your inbox": "OTP sent, please check your inbox"
  },
  "signup": {
    "Account Registration": "Account Registration",
    "A confirmation code has been sent to your email. Please enter the code below to verify your account": "A confirmation code has been sent to your email. Please enter the code below to verify your account",
    "Next": "Next",
    "Back": "back",
    "Confirm": "Confirm",
    "Create Account": "Create Account",
    "Name": "Name",
    "Last name": "Last name",
    "Company / Legal Entity": "Company / Legal Entity",
    "Country": "Country",
    "City": "City",
    "Postal Code": "Postal Code",
    "Address": "Address",
    "Phone": "Phone",
    "Email address": "Email address",
    "Password": "Password",
    "Confirm Password": "Confirm Password",
    "Code": "Code",
    "This field is required": "This field is required",
    "Email is not valid (e.g., user@example.com)": "Email is not valid (e.g., user@example.com)",
    "Password is not valid": "Password is not valid",
    "Password must be at least 8 characters long": "Password must be at least 8 characters long",
    "Password must not exceed 256 characters": "Password must not exceed 256 characters",
    "Password must include uppercase and lowercase letters, a number, and a special character (e.g., !@#$%^&*())": "Password must include uppercase and lowercase letters, a number, and a special character (e.g., !@#$%^&*())",
    "Confirm Password does not match": "Confirm Password does not match",
    "Postal Code is not valid": "Postal Code is not valid",
    "Phone is not valid (e.g., +39...)": "Phone is not valid (e.g., +39...)",
    "Accept terms & conditions": "Accept terms & conditions",
    "Minimum 3 characters are required": "Minimum 3 characters are required",
    "Maximum 50 characters allowed": "Maximum 50 characters allowed",
    "Leading and trailing spaces are not allowed": "Leading and trailing spaces are not allowed",
    "Address is not valid": "Address is not valid",
    "Email is already in use": "This email address is already registered. Please use a different email or try logging in.",
    "privacy notice": "ABB S.p.A. processes personal data particularly to grant you access and contact you. Please find more detailed information including data privacy rights in the <a href='https://new.abb.com/privacy-notice/external-stakeholders' target='_blank' class='underline text-abb-primary hover:text-abb-primary/80'>Privacy Notice</a>."
  },
  "property_services": {
    "Property Services": "Property Services",
    "Benchmarks": "Benchmarks",
    "Energy Forecasting": "Energy Forecasting",
    "Costs & Tariffs": "Costs & Tariffs",
    "You have a total of {tot} devices": "You have a total of {{tot}} devices",
    "{count} of which requires your _one": "{{count}} of which requires your ",
    "{count} of which requires your _other": "{{count}} of which require your ",
    "You are managing a total of {tot} devices, of which {connected} are «connected», {offline} «offline», {noCommunication} with no communication": "You are managing a total of {{tot}} devices, of which {{connected}} are «connected», {{offline}} «offline», {{noCommunication}} with no communication",
    "attention": "attention",
    "Add new contract": "Add new contract",
    "tabs": {
      "benchmarks": {
        "Select a benchmark to get started": "Select a benchmark to get started",
        "Benchmark": "Benchmark",
        "Category": "Category",
        "Interval": "Interval",
        "Metric": "Metric",
        "Resolution": "Resolution",
        "From": "From",
        "To": "To",
        "cancel": "cancel",
        "Apply": "Apply",
        "Export": "Export",
        "File generated successfully": "File generated successfully",
        "An error occurred while generating export file": "An error occurred while generating export file",
        "BY_PROPERTIES": "By properties",
        "BY_GROUPS": "By groups",
        "BY_DEVICES": "By devices"
      },
      "energy_forecasting": {},
      "costs_tariffs": {
        "Contract Name": "Contract Name",
        "Name": "Name",
        "Tariff": "Tariff",
        "Time": "Time",
        "Devices": "Devices",
        "Type": "Type",
        "Tag": "Tag",
        "to": "to",
        "Edit Contract": "Edit Contract",
        "Delete Contract": "Delete Contract",
        "Are you sure you want to remove contract": "Are you sure you want to remove contract",
        "Remove": "Remove",
        "Contract removed successfully": "Contract removed successfully",
        "VIRTUAL": "virtual",
        "METER_MANAGED": "Meter managed",
        "side_panel": {
          "cancel": "cancel",
          "Save": "Save",
          "Add contract": "Add contract",
          "Contract configuration": "Contract configuration",
          "Name": "Name",
          "Contract type": "Contract type",
          "Tag": "Tag",
          "Devices": "Devices",
          "Tariffs": "Tariffs",
          "Cost": "Cost",
          "Apply": "Apply",
          "From": "From",
          "To": "To",
          "Remove tariff": "Remove tariff",
          "No tariffs found": "No tariffs found",
          "New tariff": "New tariff",
          "Days": "Days",
          "From time": "From time",
          "To time": "To time",
          "Contract updated": "Contract updated",
          "Contract created": "Contract created",
          "An error occurred while updating contract": "An error occurred while updating contract",
          "An error occurred while creating contract": "An error occurred while creating contract",
          "Some fields are not valid": "Some fields are not valid",
          "VIRTUAL": "virtual",
          "METER_MANAGED": "Meter managed",
          "End time must be after start time": "End time must be after start time",
          "End date must be after start date": "End date must be after start date"
        }
      }
    }
  },
  "alarms": {
    "Alarms": "Alarms",
    "Alarms Logs": "Alarms Log",
    "New Alarm": "New Alarm",
    "You have a total of {tot} alarms, {totAlerts} of which requires your attention": "You have a total of {{tot}} alarms, {{totAlerts}} of which requires your attention",
    "tabs": {
      "list": {
        "New Alarm": "New Alarm",
        "Edit Alarm": "Edit Alarm",
        "Name": "Name",
        "Date": "Date",
        "Status": "Status",
        "Condition": "Condition",
        "Enabled": "Enabled",
        "Properties": "Properties",
        "Groups": "Groups",
        "Properties / Groups": "Properties / Groups",
        "Devices": "Devices",
        "Last update": "Last update",
        "Offline": "Offline",
        "Okay": "Okay",
        "In alarm": "In alarm",
        "Show with alarm only": "Show with alarm only",
        "Edit": "Edit",
        "Delete": "Delete",
        "Remove": "Remove",
        "remove": "remove",
        "cancel": "cancel",
        "Create": "Create",
        "Save": "Save",
        "Enable": "Enable",
        "Disable": "Disable",
        "enable": "enable",
        "disable": "disable",
        "Apply": "Apply",
        "all selected items": "all selected items",
        "Please fill in all required fields before moving forward": "Please fill in all required fields before moving forward",
        "Are you sure that you want to {action}": "Are you sure that you want to {{action}}",
        "Alarm {action} successfully": "Alarm {{action}} successfully",
        "An error occurred while {action} alarm": "An error occurred while {{action}} alarm",
        "Selected alarms are already {status}": "Selected alarms are already {{status}}",
        "Alarm deleted successfully": "Alarm deleted successfully",
        "An error occurred while deleting the alarm": "An error occurred while deleting the alarm",
        "enabled": "enabled",
        "disabled": "disabled",
        "enabled_other": "enabled",
        "disabled_other": "disabled",
        "enabling": "enabling",
        "disabling": "disabling",
        "Select the type of asset you would like to create an alarm for": "Select the type of asset you would like to create an alarm for",
        "Select assets": "Select assets",
        "Select Trigger Criteria": "Select Trigger Criteria",
        "Configure Notifications": "Configure Notifications",
        "Add Name and Description": "Add Name and Description",
        "Conditions": "Conditions",
        "Trigger": "Trigger Type",
        "Statistic": "Statistic",
        "Period": "Period",
        "{metric} graph": "{{metric}} graph",
        "Metric": "Metric",
        "currentTrms": "TRMS",
        "currentAc": "AC",
        "currentDc": "DC",
        "activePowerTotal": "Active power",
        "activeEnergyTotal": "Active energy",
        "Static": "Static",
        "threshold": "threshold",
        "Use a value as a threshold": "Use a value as a threshold",
        "Whenever {metric} is": "Whenever {{metric}} is",
        "Define alarm condition": "Define the alarm condition",
        "delay": "Delay",
        "Define delay": "Define delay",
        "CRITICAL": "Critical",
        "WARNING": "Warning",
        "than": "than",
        "Define threshold": "Define the threshold value",
        "Must be a number": "Must be a Number",
        "Notification title": "Select Contacts you wish to notify when this alarm is triggered",
        "Select Contact": "Select Contacts",
        "Description": "Description",
        "Search": "Search",
        "Next": "Next",
        "Back": "back",
        "{name} was created successfully": "{{name}} was created successfully",
        "An error occurred while creating {name}": "An error occurred while creating {{name}}",
        "{name} was updated successfully": "{{name}} was updated successfully",
        "An error occurred while updating {name}": "An error occurred while updating {{name}}"
      },
      "logs": {
        "Name": "Name",
        "Date": "Date",
        "Start Date - End Date": "Start Date - End Date",
        "Status": "Status",
        "Condition": "Condition",
        "Enabled": "Enabled",
        "Properties": "Properties",
        "Groups": "Groups",
        "Devices": "Devices",
        "Offline": "Offline",
        "Okay": "Okay",
        "In alarm": "In alarm",
        "Start date": "Start date",
        "End date": "End date",
        "Apply": "Apply",
        "Show with alarm only": "Show with alarm only",
        "Edit": "Edit",
        "Delete": "Delete",
        "cancel": "cancel",
        "Create": "Create",
        "Enable": "Enable",
        "Disable": "Disable",
        "Trigger Time": "Trigger Time",
        "Acknowledged By": "Acknowledged by",
        "Category": "Category",
        "Do you confirm to set as acknowledged this alarm?": "Do you confirm to set as acknowledged this alarm?",
        "Set as acknowledged": "Set as acknowledged",
        "Alarm acknowledged successfully": "Alarm acknowledged successfully",
        "An error occurred while acknowledging alarm": "An error occurred while acknowledging alarm",
        "Export": "Export",
        "File exported successfully": "File exported successfully",
        "An error occurred while exporting file": "An error occurred while exporting file",
        "Please enter a date range": "Please enter a date range"
      }
    }
  },
  "wizard_first_access": {
    "The setup wizard is currently in use. Please wait a moment and try again.": "The setup wizard is currently in use. Please wait a moment and try again.",
    "privacy notice": "ABB S.p.A. processes personal data particularly to grant you access and contact you. Please find more detailed information including data privacy rights in the <a href='https://new.abb.com/privacy-notice/external-stakeholders' target='_blank' class='underline text-abb-primary hover:text-abb-primary/80'>Privacy Notice</a>.",
    "Free trial period": "Free trial period",
    "Accept terms & conditions": "Accept terms & conditions",
    "As early user of the cloud application you will benefit from 12 months of unlimited device configuration... After 12 months you will have the freedom to decide using the application and purchase a license based on the N. of SCU200 connected or not using the cloud service anymore": "As early user of the cloud application you will benefit from 12 months of unlimited device configuration... After 12 months you will have the freedom to decide using the application and purchase a license based on the N. of SCU200 connected or not using the cloud service anymore",
    "earlyUserBenefitsMessagePart1": "InSite Energy Pro will benefit early users with 6 months of unlimited device configuration for free!",
    "earlyUserBenefitsMessagePart2": "After the 6 months:",
    "earlyUserBenefitsMessageItem1": "To continue using the service, a valid license must be purchased according to the specific requirements and needs.",
    "earlyUserBenefitsMessageItem2": "Users will have the freedom to decide whether to continue with the cloud service.",
    "earlyUserBenefitsMessagePart3": "For any questions or additional information, please feel free to contact your local ABB representative.",
    "Next Step": "Next Step",
    "Next": "Next",
    "Step": "Step",
    "Add New Property": "Add New Property",
    "Gateway Connection": "Next Step",
    "Devices Configuration": "Devices Configuration",
    "Final Summary": "Final Summary",
    "Token Generation": "Token Generation",
    "Insert the following token in the SCU200 webserver for starting the linking process": "Insert the following token in the SCU200 webserver for starting the linking process",
    "SCU200 Link": "SCU200 Link",
    "{name} Linked Successfully": "{{name}} Linked Successfully",
    "Fw version": "Fw version",
    "Do you want to update to the latest firmware": "Do you want to update to the latest firmware",
    "Yes": "Yes",
    "No": "No",
    "Latest firmware version updated": "Latest firmware version updated",
    "Property {name}": "Property {{name}}",
    "{name} connected": "{{name}} connected",
    "Devices Configured": "Devices Configured",
    "back": "back",
    "Configure another gateway for this property": "Configure another SCU200",
    "Configure another property": "Configure another property",
    "All settled - Go to dashboard": "Finalize",
    "Scan again": "Scan again",
    "Continue": "Continue",
    "You will have the chance to configure additional gateways or new properties also later on directly from the Dashboard": "You will have the chance to configure additional gateways or new properties also later on directly from the Dashboard",
    "Image": "Image",
    "Device": "Device",
    "Status": "Status",
    "Category": "Category",
    "Property": "Property",
    "Update firmware": "Update firmware",
    "Modbus ID": "Modbus ID",
    "Configure device": "Configure device",
    "cancel": "cancel",
    "Save": "Save",
    "Please fill in all required fields before moving forward": "Please fill in all required fields before moving forward",
    "{count} devices connected_one": "{{count}} device connected",
    "{count} devices connected_other": "{{count}} devices connected",
    "No response from the web server. Please check your internet connection or try again in a few minutes": "No response from the web server. Please check your internet connection or try again in a few minutes",
    "Retry": "Retry",
    "Waiting for webserver response": "Waiting for webserver response",
    "Retry attempt {retryCount}": "Retry attempt {{retryCount}}",
    "Device configured successfully": "Device configured successfully",
    "An error occurred while configuring device": "An error occurred while configuring device",
    "{name} was created successfully": "{{name}} was created successfully",
    "An error occurred while creating {name}": "An error occurred while creating {{name}}"
  },
  "error": {
    "connection_error": "Cannot perform the operation because of connectivity issues, please verify your network access"
  },
  "common": {
    "GREATER": "Greater",
    "LOWER": "Lower",
    "GREATEREQUAL": "Greater/Equal",
    "LOWEREQUAL": "Lower/Equal",
    "TRMS_A": "TRMS [A]",
    "AC_A": "AC [A]",
    "DC_A": "DC [A]",
    "ACTIVE_ENERGY_TOTAL": "Active energy total",
    "ACTIVE_POWER_TOTAL_W": "Active power total [W]",
    "ACTIVE_ENERGY_TOTAL_WH": "Active energy total [kWh]",
    "CURRENT_SENSOR": "Current Sensor",
    "ENERGY_METER": "Energy Meter",
    "I_O_MODULE": "I/O module",
    "INS_S_H": "INS-S/H",
    "MODBUS": "Modbus",
    "SCU200": "SCU200",
    "METER_W_MBUS": "Meter WMBus",
    "METER_LINKY": "Meter Linky",
    "METER_P1": "Meter P1",
    "THIRD_PARTY_RTU": "Third Party RTU",
    "THIRD_PARTY_TCP": "Third Party TCP",
    "ACTIVE_POWER_IMPORT_W": "Active power import [W]",
    "REACTIVE_POWER_IMPORT_VAR": "Reactive power import [VAR]",
    "ACTIVE_POWER_EXPORT_W": "Active power export [W]",
    "REACTIVE_POWER_EXPORT_VAR": "Reactive power export [VAR]",
    "REACTIVE_POWER_TOTAL_VAR": "Reactive power total [VAR]",
    "CURRENT_L1_A": "Current L1 [A]",
    "CURRENT_L2_A": "Current L2 [A]",
    "CURRENT_L3_A": "Current L3 [A]",
    "VOLTAGE_L1_V": "Voltage L1 [V]",
    "VOLTAGE_L2_V": "Voltage L2 [V]",
    "VOLTAGE_L3_V": "Voltage L3 [V]",
    "FREQUENCY_HZ": "Frequency [Hz]",
    "APPARENT_POWER_IMPORT_TOTAL_VA": "Apparent power import total [VA]",
    "APPARENT_POWER_IMPORT_L1_VA": "Apparent power import L1 [VA]",
    "APPARENT_POWER_IMPORT_L2_VA": "Apparent power import L2 [VA]",
    "APPARENT_POWER_IMPORT_L3_VA": "Apparent power import L3 [VA]",
    "ACTIVE_POWER_IMPORT_L1_W": "Active power import L1 [W]",
    "ACTIVE_POWER_IMPORT_L2_W": "Active power import L2 [W]",
    "ACTIVE_POWER_IMPORT_L3_W": "Active power import L3 [W]",
    "ACTIVE_POWER_EXPORT_L1_W": "Active power export L1 [W]",
    "ACTIVE_POWER_EXPORT_L2_W": "Active power export L2 [W]",
    "ACTIVE_POWER_EXPORT_L3_W": "Active power export L3 [W]",
    "REACTIVE_POWER_IMPORT_L1_VAR": "Reactive power import L1 [VAR]",
    "REACTIVE_POWER_IMPORT_L2_VAR": "Reactive power import L2 [VAR]",
    "REACTIVE_POWER_IMPORT_L3_VAR": "Reactive power import L3 [VAR]",
    "REACTIVE_POWER_EXPORT_L1_VAR": "Reactive power export L1 [VAR]",
    "REACTIVE_POWER_EXPORT_L2_VAR": "Reactive power export L2 [VAR]",
    "REACTIVE_POWER_EXPORT_L3_VAR": "Reactive power export L3 [VAR]",
    "THREE_PHASE_SYSTEM_VOLTAGE_V": "Three-phase system voltage [V]",
    "THREE_PHASE_SYSTEM_CURRENT_A": "Three-phase system current [A]",
    "PORT1_STATUS_CHANGE_COUNTER": "Port 1 status change counter",
    "PORT2_STATUS_CHANGE_COUNTER": "Port 2 status change counter",
    "PORT3_STATUS_CHANGE_COUNTER": "Port 3 status change counter",
    "PORT4_STATUS_CHANGE_COUNTER": "Port 4 status change counter",
    "PORT1_PULSE_COUNTER_ACCUMULATED": "Port 1 pulse counter accumulated",
    "PORT2_PULSE_COUNTER_ACCUMULATED": "Port 2 pulse counter accumulated",
    "PORT3_PULSE_COUNTER_ACCUMULATED": "Port 3 pulse counter accumulated",
    "PORT4_PULSE_COUNTER_ACCUMULATED": "Port 4 pulse counter accumulated",
    "SWITCH_1": "Switch 1",
    "SWITCH_2": "Switch 2",
    "TEMPERATURE_1_C": "Temperature 1 [°C]",
    "TEMPERATURE_2_C": "Temperature 2 [°C]",
    "TEMPERATURE_3_C": "Temperature 3 [°C]",
    "TEMPERATURE_4_C": "Temperature 4 [°C]",
    "INPUT_VOLTAGE_V": "Input voltage [V]",
    "VOLTAGE_L1_L2_V": "Voltage L1-L2 [V]",
    "VOLTAGE_L3_L2_V": "Voltage L3-L2 [V]",
    "VOLTAGE_L1_L3_V": "Voltage L1-L3 [V]",
    "CURRENT_N_A": "Current N [A]",
    "ACTIVE_POWER_L1_W": "Active power L1 [W]",
    "ACTIVE_POWER_L2_W": "Active power L2 [W]",
    "ACTIVE_POWER_L3_W": "Active power L3 [W]",
    "REACTIVE_POWER_L1_VAR": "Reactive power L1 [VAR]",
    "REACTIVE_POWER_L2_VAR": "Reactive power L2 [VAR]",
    "REACTIVE_POWER_L3_VAR": "Reactive power L3 [VAR]",
    "APPARENT_POWER_L1_VA": "Apparent power L1 [VA]",
    "APPARENT_POWER_L2_VA": "Apparent power L2 [VA]",
    "APPARENT_POWER_L3_VA": "Apparent power L3 [VA]",
    "CURRENT_QUADRANT_L1": "Current quadrant L1",
    "CURRENT_QUADRANT_L2": "Current quadrant L2",
    "CURRENT_QUADRANT_L3": "Current quadrant L3",
    "POWER_FACTOR_L1": "Power factor L1",
    "POWER_FACTOR_L2": "Power factor L2",
    "POWER_FACTOR_L3": "Power factor L3",
    "POWER_FACTOR_TOTAL": "Power factor total",
    "APPARENT_POWER_TOTAL_VA": "Apparent power total [VA]",
    "COS_PHI_L1": "Cos phi L1",
    "COS_PHI_L2": "Cos phi L2",
    "COS_PHI_L3": "Cos phi L3",
    "COS_PHI_3_PHASE": "Cos phi 3 phase",
    "CTL1_L2_L3_RATIO_DENOMINATOR": "CTL1 L2-L3 ratio denominator",
    "CURRENT_QUADRANT_TOTAL": "Current quadrant total",
    "ACTIVE_ENERGY_NET_TOTAL": "Active energy net total [kWh]",
    "REACTIVE_ENERGY_EXPORT_TOTAL": "Reactive energy export total",
    "ACTIVE_ENERGY_CO2": "Active energy CO2",
    "REACTIVE_ENERGY_IMPORT_TOTAL": "Reactive energy import total",
    "ACTIVE_ENERGY_CURRENCY": "Active energy currency",
    "ACTIVE_ENERGY_IMPORT_TOTAL": "Active energy import total",
    "APPARENT_ENERGY_NET_TOTAL": "Apparent energy net total",
    "APPARENT_ENERGY_NET_L2": "Apparent energy net L2",
    "ACTIVE_ENERGY_EXPORT_TOTAL": "Active energy export total",
    "APPARENT_ENERGY_NET_L1": "Apparent energy net L1",
    "REACTIVE_ENERGY_NET_TOTAL": "Reactive energy net total",
    "APPARENT_ENERGY_NET_L3": "Apparent energy net L3",
    "ACTIVE_ENERGY_EXPORT_TOTAL_KWH": "Active energy export total [kWh]",
    "ACTIVE_ENERGY_IMPORT_TOTAL_KWH": "Active energy import total [kWh]",
    "ACTIVE_ENERGY_NET_TOTAL_KWH": "Active energy net total [kWh]",
    "APPARENT_ENERGY_NET_L1_KWH": "Apparent energy net L1 [kWh]",
    "APPARENT_ENERGY_NET_L2_KWH": "Apparent energy net L2 [kWh]",
    "APPARENT_ENERGY_NET_L3_KWH": "Apparent energy net L3 [kWh]",
    "APPARENT_ENERGY_NET_TOTAL_KWH": "Apparent energy net total [kWh]",
    "REACTIVE_ENERGY_EXPORT_TOTAL_KWH": "Reactive energy export total [kWh]",
    "REACTIVE_ENERGY_IMPORT_TOTAL_KWH": "Reactive energy import total [kWh]",
    "REACTIVE_ENERGY_NET_TOTAL_KWH": "Reactive energy net total [kWh]",
    "ACTIVE_ENERGY": "Active Energy",
    "APPARENT_ENERGY_NET": "Apparent Energy Net",
    "ENERGY_KWH": "Active Energy [kWh]",
    "ACTIVE_ENERGY_IMPORT": "Active Energy Import",
    "PORT1_PULSE_COUNTER_ACCUMULATED_VALUE": "Port 1 pulse counter accumulated value",
    "PORT2_PULSE_COUNTER_ACCUMULATED_VALUE": "Port 2 pulse counter accumulated value",
    "PORT3_PULSE_COUNTER_ACCUMULATED_VALUE": "Port 3 pulse counter accumulated value",
    "PORT4_PULSE_COUNTER_ACCUMULATED_VALUE": "Port 4 pulse counter accumulated value",
    "PORT1_STATE": "Port 1 state",
    "PORT2_STATE": "Port 2 state",
    "PORT3_STATE": "Port 3 state",
    "PORT4_STATE": "Port 4 state",
    "CURRENT_HARMONICS_THD_L1": "Current harmonics THD L1",
    "CURRENT_HARMONICS_THD_L2": "Current harmonics THD L2",
    "CURRENT_HARMONICS_THD_L3": "Current harmonics THD L3",
    "CURRENT_HARMONICS_THD_N": "Current harmonics THD N",
    "PHASE_ANGLE_CURRENT_L1": "Phase angle current L1",
    "PHASE_ANGLE_CURRENT_L2": "Phase angle current L2",
    "PHASE_ANGLE_CURRENT_L3": "Phase angle current L3",
    "POWER_ANGLE_POWER_L1": "Power angle power L1",
    "POWER_ANGLE_POWER_L2": "Power angle power L2",
    "POWER_ANGLE_POWER_L3": "Power angle power L3",
    "POWER_ANGLE_POWER_TOTAL": "Power angle power total",
    "PHASE_ANGLE_VOLTAGE_L1": "Phase angle voltage L1",
    "PHASE_ANGLE_VOLTAGE_L2": "Phase angle voltage L2",
    "PHASE_ANGLE_VOLTAGE_L3": "Phase angle voltage L3",
    "VOLTAGE_HARMONICS_THD_L1": "Voltage harmonics THD L1",
    "VOLTAGE_HARMONICS_THD_L2": "Voltage harmonics THD L2",
    "VOLTAGE_HARMONICS_THD_L3": "Voltage harmonics THD L3",
    "REACTIVE_POWER_IMPORT_TOTAL_VAR": "Reactive power import total [VAR]",
    "REACTIVE_POWER_EXPORT_TOTAL_VAR": "Reactive power export total [VAR]",
    "ACTIVE_POWER_IMPORT_TOTAL_W": "Active power import total [W]",
    "ACTIVE_ENERGY_IMPORT_L1": "Active energy import L1",
    "ACTIVE_ENERGY_IMPORT_L2": "Active energy import L2",
    "ACTIVE_ENERGY_IMPORT_L3": "Active energy import L3",
    "ACTIVE_ENERGY_EXPORT_L1": "Active energy export L1",
    "ACTIVE_ENERGY_EXPORT_L2": "Active energy export L2",
    "ACTIVE_ENERGY_EXPORT_L3": "Active energy export L3",
    "ACTIVE_ENERGY_NET_L1": "Active energy net L1",
    "ACTIVE_ENERGY_NET_L2": "Active energy net L2",
    "ACTIVE_ENERGY_NET_L3": "Active energy net L3",
    "REACTIVE_ENERGY_EXPORT_L1": "Reactive energy export L1",
    "REACTIVE_ENERGY_EXPORT_L2": "Reactive energy export L2",
    "REACTIVE_ENERGY_EXPORT_L3": "Reactive energy export L3",
    "REACTIVE_ENERGY_IMPORT_L1": "Reactive energy import L1",
    "REACTIVE_ENERGY_IMPORT_L2": "Reactive energy import L2",
    "REACTIVE_ENERGY_IMPORT_L3": "Reactive energy import L3",
    "REACTIVE_ENERGY_NET_L1": "Reactive energy net L1",
    "REACTIVE_ENERGY_NET_L2": "Reactive energy net L2",
    "REACTIVE_ENERGY_NET_L3": "Reactive energy net L3",
    "ACTIVE_POWER_EXPORT_TOTAL_W": "Active power export total [W]",
    "ACTIVE_POWER_TOTAL_KW": "Active power total [kW]",
    "TOTAL_COST_EUR": "Total cost [€]",
    "ACTIVE_POWER_TOTAL": "Active power total",
    "ACTIVE_IMPORT_TOTAL": "Active import total",
    "ACTIVE_EXPORT_TOTAL": "Active export total",
    "REACTIVE_IMPORT_TOTAL": "Reactive import total",
    "REACTIVE_EXPORT_TOTAL": "Reactive export total",
    "PORT1_STATUS_CHANGE": "Port 1 status change",
    "PORT2_STATUS_CHANGE": "Port 2 status change",
    "PORT3_STATUS_CHANGE": "Port 3 status change",
    "PORT4_STATUS_CHANGE": "Port 4 status change",
    "SYSTEM": "System",
    "CROSS_UP": "Cross-Up",
    "CROSS_DOWN": "Cross-Down",
    "STATUS_CHANGE": "Status Change",
    "COMMUNICATION_FAILURE": "Communication Failure",
    "COMMUNICATION_RESTORE": "Communication Restore",
    "STATUS_CHANGE_TO_CLOSED": "Status Change To Closed",
    "STATUS_CHANGE_TO_OPEN": "Status Change To Open",
    "AUTOMATION_SUCCESS": "Automation Success",
    "AUTOMATION_FAILURE": "Automation Failure",
    "VALUE_MATCH": "Value Match",
    "STATUS_CHANGE_TO_ON": "Status Change To On",
    "STATUS_CHANGE_TO_OFF": "Status Change To Off",
    "VALUE_CHANGE": "Value Change",
    "INSITE_BUS": "InSite Bus",
    "METERING_MODULES": "Metering Modules",
    "WIRELESS_M_BUS": "Wireless M-Bus",
    "USB_DEVICE": "USB Device",
    "MODBUS_RTU_RS485_DEVICES": "Modbus RTU RS485 Devices",
    "MODBUS_TCP_DEVICES": "Modbus TCP Devices",
    "GOOD": "Good",
    "TO_BE_IMPROVED": "To be improved",
    "CONSUMPTION": "Consumption",
    "TOTAL_COST": "Total Cost",
    "ACTIVE_ENERGY_EXPORT": "Active Energy Export",
    "ACTIVE_ENERGY_NET": "Active Energy Net",
    "APPARENT_ENERGY_EXPORT": "Apparent Energy Export",
    "APPARENT_ENERGY_IMPORT": "Apparent Energy Import",
    "REACTIVE_ENERGY_NET": "Reactive Energy Net",
    "REACTIVE_ENERGY_IMPORT": "Reactive Energy Import",
    "REACTIVE_ENERGY_EXPORT": "Reactive Energy Export",
    "GAS_CONSUMPTION": "Gas Consumption",
    "WATER_CONSUMPTION": "Water Consumption",
    "CHARGING_STATE": "Charging State",
    "FIRMWARE_VERSION": "Firmware Version",
    "INPUT_1_COUNTER": "Input 1 Counter",
    "INPUT_2_COUNTER": "Input 2 Counter",
    "INPUT_3_COUNTER": "Input 3 Counter",
    "INPUT_4_COUNTER": "Input 4 Counter",
    "INPUT_3_CURRENT_STATE": "Input 3 Current State",
    "INPUT_3_STORED": "Input 3 Stored",
    "INPUT_4_CURRENT_STATE": "Input 4 Current State",
    "INPUT_4_STORED": "Input 4 Stored",
    "MESSAGE1": "Message 1",
    "MESSAGE2": "Message 2",
    "OUTPUT_1": "Output 1",
    "OUTPUT_2": "Output 2",
    "OUTPUT_3": "Output 3",
    "OUTPUT_4": "Output 4",
    "REFERENCE_APPARENT_POWER": "Reference apparent power",
    "REFERENCE_BREAKING_CAPACITY": "Reference breaking capacity",
    "RELAY1": "Relay 1",
    "RELAY2": "Relay 2",
    "RELAY3": "Relay 3",
    "RELAY4": "Relay 4",
    "RELAY5": "Relay 5",
    "RELAY6": "Relay 6",
    "RELAY7": "Relay 7",
    "RELAY8": "Relay 8",
    "SERIAL_NUMBER": "Serial Number",
    "SOCKET_LOCK_STATE": "Socket Lock State",
    "STATUS_REGISTER": "Status register",
    "VOLTAGE_HARMONICS_THD_L1_L2": "Voltage harmonics THD L1-L2",
    "VOLTAGE_HARMONICS_THD_L2_L3": "Voltage harmonics THD L2-L3",
    "VOLTAGE_HARMONICS_THD_L3_L2": "Voltage harmonics THD L3-L2",
    "VOLTAGE_HARMONICS_THD_L1_L3": "Voltage harmonics THD L1-L3",
    "PHASE_ANGLE_POWER_L1": "Phase angle power L1",
    "PHASE_ANGLE_POWER_L2": "Phase angle power L2",
    "PHASE_ANGLE_POWER_L3": "Phase angle power L3",
    "PHASE_ANGLE_POWER_TOTAL": "Phase angle power total",
    "ACTIVE_POWER_L1": "Active power L1",
    "ACTIVE_POWER_L2": "Active power L2",
    "ACTIVE_POWER_L3": "Active power L3",
    "APPARENT_ENERGY_EXPORT_L1": "Apparent energy export L1",
    "APPARENT_ENERGY_EXPORT_L2": "Apparent energy export L2",
    "APPARENT_ENERGY_EXPORT_L3": "Apparent energy export L3",
    "APPARENT_ENERGY_EXPORT_TOTAL": "Apparent energy export total",
    "APPARENT_ENERGY_IMPORT_L1": "Apparent energy import L1",
    "APPARENT_ENERGY_IMPORT_L2": "Apparent energy import L2",
    "APPARENT_ENERGY_IMPORT_L3": "Apparent energy import L3",
    "APPARENT_ENERGY_IMPORT_TOTAL": "Apparent energy import total",
    "APPARENT_POWER_TOTAL": "Apparent power total",
    "APPARENT_POWER_L1":"Apparent power L1",
    "APPARENT_POWER_L2":"Apparent power L2",
    "APPARENT_POWER_L3":"Apparent power L3",
    "REACTIVE_POWER_L1": "Reactive power L1",
    "REACTIVE_POWER_L2": "Reactive power L2",
    "REACTIVE_POWER_L3": "Reactive power L3",
    "REACTIVE_POWER_TOTAL": "Reactive power total",
    "ACTIVE_ENERGY_EXPORT_L1_KWH": "Active energy export L1 [kWh]",
    "ACTIVE_ENERGY_EXPORT_L2_KWH": "Active energy export L2 [kWh]",
    "ACTIVE_ENERGY_EXPORT_L3_KWH": "Active energy export L3 [kWh]"
    

    }
}
